import { createApp } from 'vue'
import './index.css'
import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from 'gsap/ScrollSmoother';

// Components
import App from './App.vue'
import { i18n } from './i18n'
import router from './router'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')

